import AddressGroupSummary from "./AddressGroupSummary";
import AddressSummary from "./AddressSummary";
import {AddressWithGroupApiDto} from "../../api/model/rest";

export default class AddressesWithGroups {

	/**
	 * @param {AddressSummary[]} addresses List of addresses.
	 * @param {AddressGroupSummary[]} groups List of group of addresses.
	 */
	constructor(public readonly addresses: AddressSummary[], public readonly groups: AddressGroupSummary[]) {}

	static fromJson(json: AddressWithGroupApiDto) {
		const addresses = json.addresses.map(AddressSummary.fromJson);
		const groups = json.postcodes.map(AddressGroupSummary.fromJson);
		return new AddressesWithGroups(addresses, groups)
	}
}